export const MY_MARKET_INFO_PROFILE_PATH = 'user/profile';

const URL_REGEX =
    '((https?|s?ftp):\\/\\/)?' + // protocol
    '((([\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEFa-zà-öø-ÿß\\d]+(-+[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEFa-zà-öø-ÿß\\d-]*[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEFa-zà-öø-ÿß\\d])*)\\.)+[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEFa-zà-öø-ÿß]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?' + // port
    '(\\/[-a-zà-öø-ÿß\\d%_&,\\:\'.~+@]*)*' + // path
    '(\\?[*@;:&a-zà-öø-ÿß\\d%_,\\./\'~+=-]*)?' + // query string
    '(#[-!a-zà-öø-ÿß\\d_/]*)?'; //fragment locator

export const IS_URL_REGEX = new RegExp('^' + URL_REGEX + '$', 'i');
export const CONTAINS_URL_REGEX = new RegExp(URL_REGEX, 'i');

// Maximum number of tasks of a single task type. Used as the ceiling when
// ordering work (AllocateWork) and when configuring partner task-type
// allocation templates, and as the fallback cap in AllocateWork when a task
// type does not define its own MaxCount.
export const DEFAULT_MAX_TASK_COUNT = 50;

// Page types offered when ordering Page Creation / Page Optimization work. The selected
// value is stored verbatim on the workflow under KeyEnum.PageType, so these strings are
// the contract between ordering and the specialist task screens.
export const PAGE_TYPES = [
  'Home',
  'About Us',
  'Contact Us',
  'Category Overview (Pathway)',
  'Product/Service Description',
  'Location',
  'Info'
];

export const LOCATION_PAGE_TYPE = 'Location';
